import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ref, set } from 'firebase/database'; // from Firebase SDK
import { database } from '../FireBaseConfig/OAuth.js'; // Your Firebase config

const About = () => {
  // Any logic (e.g. state, hooks, Firebase reads/writes) can go here
  return (
    <div>
      about
    </div>
  );
};

export default About;
